$(document).ready(function() {
	if(!document.querySelector('.GPC0014')) return false;

	var $obj=$('.GPC0014');
	function checkViewAll($obj2) {
		var reviewCount = parseInt($obj2.data('review-count')),
			reviewRating = parseInt($obj2.data('review-rating')),
			reviewURL = xssfilter($obj2.data('all-review-url'));
		
		// do not use see all reviews button in gp
		/*if(reviewCount >= 5 && reviewRating > 3) {
			$obj.find('.pdp-btn-area').addClass('active').find('.btn-box a.btn').attr('href', reviewURL);
		} else {
			$obj.find('.pdp-btn-area').removeClass('active');
		}*/
		$obj.find('.pdp-btn-area').removeClass('active');

		//$obj.find('.overlayer').removeAttr('id');
		//$obj2.find('.overlayer').attr('id', 'waGPC0014_0');
		//$obj.find('.pdp-btn-area').addClass('active').find('.btn-box a.btn').attr('aria-describedby', 'waGPC0014_0');
	}
	$obj.find('.pdp-layer-tab .pdp-layer-tab-desktop-list a, .pdp-layer-tab .pdp-layer-tab-mobile-list a').off('click.C14').on('click.C14', function(e) {
		e.preventDefault();
		if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
			var modelId = $(this).data('model');
			if(modelId) {
				$(this).closest('.component').find('.pdp-conts-area').html('<div data-bv-show="reviews" data-bv-product-id="'+modelId+'"></div>');
			}
		} else {
			ePrivacyCookies.view('load', '', $(this).closest('.component').find('.pdp-conts-area'));
		}
		checkViewAll($(this));
	});
	var currentObj = ($obj.find('.pdp-layer-tab .pdp-layer-tab-desktop-list a.active:visible').length>0) ? $obj.find('.pdp-layer-tab .pdp-layer-tab-desktop-list a.active:visible') : $obj.find('.pdp-layer-tab .pdp-layer-tab-mobile-list a.active:visible');
	if($obj.find('.pdp-layer-tab .pdp-layer-tab-desktop-list a.active:visible').length>0 || $obj.find('.pdp-layer-tab .pdp-layer-tab-mobile-list a.active:visible').length>0) {
		checkViewAll(currentObj);
	}
	if(typeof ePrivacyCookies=='undefined' || ePrivacyCookies.get('LGCOM_IMPROVEMENTS')) {
	} else {
		/*LGEES-15 modify*/ 
		if(COUNTRY_CODE.toLowerCase()=='es'&& $obj.find('.pdp-conts-area').attr('id')=='pdpBVRRContainer'){
		}else{
			ePrivacyCookies.view('load', '', $obj.find('.pdp-conts-area'));
		}
		/*LGEES-15 modify*/
	}
	
	/* LGEIN-335 : 20210123 add */
	var $slick = function(){
		$obj.each(function(){
			var $objNext = $(this).find('.package-next');
			var $objPrev = $(this).find('.package-prev');
			$(this).find('.pdp-layer-tab-desktop-list .items').slick({
				listStyle: true, // WA-GPC0012-01
				autoplay: false,
				infinite: false,
				slidesToShow: 4,
				slidesToScroll: 4,
				dots: false,
				nextArrow:$objNext,
				prevArrow:$objPrev,
				responsive: [
					{
						breakpoint: 1200,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					}, {
						breakpoint: 768,
						settings: {
							dots: true,
							arrows: false,
							slidesToShow: 1,
							slidesToScroll: 1
						}
					}
				]
			});
		});
	};
	$slick();
	/*// LGEIN-335 : 20210123 add */
});